// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Components
import { RadioGroupV2 } from 'src/components/HTKit/Forms/RadioV2';
import { useModalToggle } from 'src/components/HTKit/Modals/ModalV2';
import Button, { THEMES } from 'src/components/HTKit/Forms/Button';
import Selector from 'src/components/HTKit/Selector/Selector';
import ProductInstallModal from './ProductInstallModal';
// Constants
import PRODUCT_TYPE from './constants';
// Styles
import styles from './styles.scss';

const ProductInstallationOptions = ({
  bullets,
  onChange,
  variantOption,
  value,
  addToCart,
  priceDetails,
  isProductVariant,
  memberInstallationPrices,
  isMember,
  // ...rest
}) => {
  const { isVisible, toggle } = useModalToggle();
  const button = (
    <Button theme={THEMES.V2PRIMARY} onClick={addToCart}>
      Add Device &amp; Installation to Cart
    </Button>
  );
  const targetProducts = isMember ? memberInstallationPrices : priceDetails;
  const {
    installationPrice,
    installationPriceFormatted,
    serviceOnlyPrice,
    serviceOnlyPriceFormatted,
  } = targetProducts;
  const isSavings = serviceOnlyPrice > installationPrice;

  const Price = () => {
    if (!installationPrice) return null;
    return (
      <p className="paddingX-tiny1 n700 p2">
        + {installationPriceFormatted}
        {isSavings && (
          <span className="paddingX-tiny1 line-through n300 p2">{serviceOnlyPriceFormatted}</span>
        )}
      </p>
    );
  };
  const showAdditionalText = !isProductVariant;
  const buttonLabel = !showAdditionalText ? 'With Installation' : 'Add Installation';

  return (
    <>
      <div className={cn('paddingTop-small1', styles.installation, styles.borderTop)}>
        <p className="p1 n900">Installation:</p>
        <p onClick={toggle} className={cn('caption', styles.link)}>
          What comes with installation?
        </p>
      </div>
      <RadioGroupV2
        value={variantOption}
        onChange={onChange}
        columnClassName={styles.selectorContainer}
      >
        <Selector
          value={PRODUCT_TYPE.NO_INSTALLATION}
          label="No Installation"
          wrapperClass={cn('paddingRight-small', styles.wrapper)}
        />
        <Selector
          value={PRODUCT_TYPE.WITH_INSTALLATION}
          label={buttonLabel}
          wrapperClass={styles.wrapper}
          text={<Price />}
          showAdditionalText={showAdditionalText}
        />
      </RadioGroupV2>
      <ProductInstallModal
        isVisible={isVisible}
        hide={toggle}
        header="Expert Install &amp; Setup"
        footerElement3={button}
        value={value}
        bullets={bullets}
      />
    </>
  );
};

ProductInstallationOptions.propTypes = {
  onChange: PropTypes.func.isRequired,
  addToCart: PropTypes.func,
  bullets: PropTypes.array,
  value: PropTypes.string,
  variantOption: PropTypes.string,
  serviceOnlyPrice: PropTypes.string,
  priceDetails: PropTypes.shape({
    installationPrice: PropTypes.number,
    serviceOnlyPrice: PropTypes.number,
  }),
  memberInstallationPrices: PropTypes.shape({
    installationPrice: PropTypes.number,
    serviceOnlyPrice: PropTypes.number,
  }),
  isProductVariant: PropTypes.bool,
  isMember: PropTypes.bool,
};

export default ProductInstallationOptions;
